// TODO: move this component to a separate parent component out of siteview later.
import { CloseCircleOutlined } from '@ant-design/icons'
import { Draggable } from 'components/Draggable'
import React, { ReactNode, useEffect } from 'react'
import styled from 'styled-components'
import { Vector2 } from 'three'

const PopupMenuContainer = styled.div`
  border-radius: 16px;
  opacity: 0.85;
  background-color: rgb(60, 60, 60);
  border: 0.5px #fffa solid;
  padding: 0.5rem;
  color: white;
  line-height: 1.25rem;
  text-align: center;
  display: flex;
  flex-direction: column;
  min-width: 160px;
  overflow: hidden;
  width: 100%;

  transition:
    width 200ms,
    height 200ms;
`

const DraggableHandle = styled.div`
  position: absolute;
  top: 12px;
  left: 50%;
  transform: translate(-50%, 0);
  width: 60px;
  height: 4px;
  border-radius: 2px;
  background-color: rgba(255, 255, 255, 0.6);
`

const CloseButtonContainer = styled.div`
  position: absolute;
  top: 8px;
  right: 10px;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.6);
`

const TitleContainer = styled.div`
  font-size: 16px;
  padding: 15px 30px 0;
`

const ContentContainer = styled.div`
  display: block;
  padding-top: 10px;
`

const FixedPlacedDraggable = styled(Draggable)`
  position: fixed !important;
  transform: translate(
    -50%,
    calc(-100%)
  ); // the "top" and "left" properties will move the element according to the bottom center
`

// TODO: why are html overlay z-indices so high?
const zIndexToCoverHTMLOverlays = 99999999

interface OverlayPopupMenuProps {
  title: string
  startPosition: Vector2
  closeFunction: () => void
  getDraggableGroup: () => React.RefObject<HTMLDivElement | null>[]
  children: ReactNode
  assignRef?: React.RefObject<HTMLDivElement>
  notCloseable?: boolean
}

export const OverlayPopupMenu: React.FC<OverlayPopupMenuProps> = (props) => {
  const { closeFunction } = props
  useEffect(() => {
    const closeOnEscHandler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        closeFunction()
      }
    }
    window.addEventListener('keydown', closeOnEscHandler)
    return () => {
      window.removeEventListener('keydown', closeOnEscHandler)
    }
  }, [closeFunction])
  return (
    <FixedPlacedDraggable
      style={{
        left: props.startPosition.x + 'px',
        top: props.startPosition.y + 'px',
        zIndex: zIndexToCoverHTMLOverlays,
      }}
      groupZIndex={zIndexToCoverHTMLOverlays}
      getDraggableGroup={props.getDraggableGroup}>
      <PopupMenuContainer ref={props.assignRef}>
        <DraggableHandle />
        {!props.notCloseable && (
          <CloseButtonContainer
            onClick={() => {
              closeFunction()
            }}>
            <CloseCircleOutlined
              style={{ transform: 'scale(1.5) translate(0, 0)' }}
            />
          </CloseButtonContainer>
        )}
        <TitleContainer>{props.title}</TitleContainer>
        <ContentContainer>{props.children}</ContentContainer>
      </PopupMenuContainer>
    </FixedPlacedDraggable>
  )
}
